import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom'
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import configureStore from './redux/store'
import { HelmetProvider } from 'react-helmet-async';

import { ModalProvider } from './context/ModalContext';
import { SocketProvider } from './context/SocketContext';
import { WindowProvider } from './context/WindowContext';
import { MediaOverlayProvider } from './context/MediaOverlayContext';
import MediaOverlay from './components/MediaOverlay';


const store = configureStore();


if (process.env.NODE_ENV !== 'production') {
  // restoreCSRF();
  // window.csrfFetch = csrfFetch;
  window.store = store;
}



function Root(){
  

  return(
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
            <ModalProvider>
              <MediaOverlayProvider>
              <SocketProvider>
                <WindowProvider>
                    <App />
                    <MediaOverlay />
                </WindowProvider>
              </SocketProvider>
              </MediaOverlayProvider>
            </ModalProvider>
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  );
}


ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root')
);
